// Import React Apps
import './apps/cart-drawer/index.jsx'

// Sections
import { setupHeader } from './sections/header.js'
import { setupHeros } from './sections/hero.js'
import { setupImageWithText } from './sections/image-with-text.js'
import { setupBlogSlider } from './sections/blog-slider.js'
import { setupSlider } from './sections/slider.js'
import { setupProductSection } from './sections/main-product.js'
import { setupRelatedProducts } from './sections/related-products.js'
import { setupCollection } from './sections/collection.js'

// Components
import { setupCustomModal } from './components/CustomModal.js'
import { setupVideos } from './components/Video.js'

document.addEventListener('DOMContentLoaded', () => {
  const langSelector = document.querySelector('.home-language-selector__hidden')
  if(langSelector) {
    if(typeof Cookies.get('home-language') == 'undefined') 
      document.querySelector('.home-language-selector__hidden').classList.remove('home-language-selector__hidden')
    else
      document.body.classList.remove('home-language--open')
  } else
    document.body.classList.remove('home-language--open')
  
  // Sections
  setupHeader()
  setupHeros()
  setupImageWithText()
  setupBlogSlider()
  setupSlider()
  setupProductSection()
  setupRelatedProducts()
  setupCollection()

  // Components
  setupCustomModal()
  setupVideos()
})